<template>
  <div class="tab-item-container" :style=assignStyles>
    <v-divider></v-divider> 
    <v-card elevation="0" v-if="showLoader" height="100%">
      <v-container class="loader-popover">
        <v-progress-circular indeterminate size=50 :width="5"></v-progress-circular>
      </v-container>
    </v-card>
    <v-card elevation="0" v-if="!showLoader">
      <div class="timezone-assign">
        <span >All due dates saved to instructor's timezone:</span>
        <v-btn flat text class="branded-text" @click="slideOut({toggle: true, view: 'profile'})">
            <Tooltip top>
              <span>{{instructorData.timezone}}</span>
              <template v-slot:text>
                Change Timezone
              </template>
            </Tooltip>
        </v-btn>
        <span v-if="instructorData.timezoneCurrent != instructorData.timezoneAbr" class="assign-light pl-4">Traveling? Times displayed in: <strong>{{instructorData.timezoneCurrent}}</strong></span>
      </div>
      <div class="assignList">
        <template v-for="assignClass in classes.data"> 
            <v-container fluid px-4 py-2>
              <v-layout row>
                <v-flex xs1 align-self-center>
                  <div
                    :style="{ position: 'relative' }">
                    <img
                      v-if="assignClass.lmsType === 'Google'"
                      class="googleAvatarSmall"
                      src="https://bunny.playposit.com/images/add_to_googleclassroom.png">
                    <v-icon v-if="assignClass.lmsType" :color="assignClass.default_color">folder</v-icon>
                  </div>
                  <v-icon v-if="!assignClass.lmsType" :color="assignClass.default_color" class="mt-3">folder_shared</v-icon>
                </v-flex>
                <v-flex xs11>
                  <v-container fluid px-0 py-0>
                   <v-layout row>
                     <v-flex xs12>{{ assignClass.name }}</v-flex>
                   </v-layout>
                   <v-layout row justify-space-between>
                    <v-flex xs4 align-self-center>
                      <el-date-picker v-if="
                        (
                          assignPlaylist
                          && (!assignClass.lmsType
                          || assignClass.lmsType === 'Google' 
                          || assignClass.lmsType === 'SchoologyFree'
                          || assignClass.lmsType === 'Clever')
                        )"
                        :v-loading="loadingAssignedDates"
                        class="datepicker"
                        v-model="mappedAssignedDates[assignClass.id]"
                        type="datetime"
                        :placeholder="assignClass.id === null ? 'Assigned. No Due Date' : 'Unassigned - Select Date' "
                        format="MM/dd/yyyy hh:mm A"
                        :disabled="instructorData.timezone === null"
                        @change="handlePlaylistAssigned(assignClass.id)"
                        >
                      </el-date-picker>
                      <el-date-picker v-else-if="
                        (
                          !assignClass.lmsType
                          || assignClass.lmsType === 'Google' 
                          || assignClass.lmsType === 'SchoologyFree'
                          || assignClass.lmsType === 'Clever'
                        )"
                        v-loading="loadingAssignedDates"
                        class="datepicker"
                        v-model="assignedDates[assignClass.id]"
                        type="datetime"
                        :placeholder="assignClass.id === null ? 'Assigned. No Due Date' : 'Unassigned - Select Date' "
                        format="MM/dd/yyyy hh:mm A"
                        :disabled="instructorData.timezone === null"
                        @change="assignSection(assignClass.id)"
                        >
                      </el-date-picker>
                      <span v-if="
                        assignClass.lmsType != null 
                        && assignClass.lmsType != 'Google' 
                        && assignClass.lmsType != 'SchoologyFree'
                        && assignClass.lmsType != 'Clever'
                      ">Please assign bulb from {{(assignClass.lmsType === 'Default') ? 'LMS' : assignClass.lmsType }}</span>
                    </v-flex>
                    <v-flex xs4 px-3>
                     <v-select
                        v-if="!assignPlaylist && _.get(dialogShow, 'data.config.lmb.peer_review') && assignClass.lmsType === null && groupSets[assignClass.id]"
                        class="group-select"
                        :items="groupSets[assignClass.id]"
                        item-text="name"
                        item-value="id"
                        v-model="assignedGroupSets[assignClass.id]"
                        label="Select Group Set"
                        clearable
                        @change="assignGroup(assignClass.id)"
                        :disabled="instructorAjaxing"
                      ></v-select>
                    </v-flex>
                    <v-flex xs3 align-self-center class='text-xs-center'> 
                      <template v-if="assignPlaylist ? mappedAssignedDates[assignClass.id] : assignedDates[assignClass.id]">
                         <v-btn  v-if="assignBroadcast" outline @click="broadcast(assignClass.id )" class="branded-text link-button">
                          <v-icon class="link-icon" left color="primary">link</v-icon>
                          <span class="link-text">Link</span>
                        </v-btn>
                        <v-btn
                          v-else-if="!assignClass.lmsType 
                          || (assignClass.lmsType === 'Google' || assignClass.lmsType === 'SchoologyFree' || assignClass.lmsType === 'Clever')"
                          outline
                          @click="hotlinkAssignLink(assignClass)"
                          class="branded-text link-button"
                        >
                          <v-icon class="link-icon" left color="primary">link</v-icon>
                          <span class="link-text">Link</span>
                        </v-btn>
                      </template>
                    </v-flex>   
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
          
        </template>
      </div>
      <!--      <h1>No Classes. Create a class before assigning bulb.</h1>-->
    </v-card>
  </div>
</template>

<script>
/* global _ */
/* global btoa */
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import _ from 'lodash';

export default {
  name: 'AssignCourse',
  props: [ 
    'assignBroadcast',
    'assignPlaylist',
    'hotlinkAssignLink',
    'playlist',
  ], 
  data() {
    return {
      groupAssignments: {},
      loadingAssignedDates: false,
      mappedAssignedDates: {},
    };
  },
  computed: {
    ...mapState([
      'popoverDataLoading',
    ]),
    ...mapState('instructors', [
      'playlistAssignedDates',
      'playlistModalLoading',
      'classes'
    ]),
    ...mapGetters([
      'dialogShow',
      'free',
      'instructorAjaxing',
      'instructorData',
      'instructorType',
    ]),
    ...mapGetters('instructors', [
      'assignedBulbSections',
      'assignedDates',
      'assignedGroupSets',
      'assignedDatesOriginal',
      'groupSets',
      'queryParamsInstructors',
    ]),
    assignStyles() {
      //set assign table height based on warning
      return {
        // height: this.queryParamsInstructors.section_id === '' ? '250px' : '60px', 
        height: '250px', 
        overflow: 'auto',
      }
    },
    baPercentage(){
      if (this.instructorType === 'free') {
        return (this.free.ba_limit / 100) * 100; 
      }
      return 0;
    },
    showLoader(){
      return this.popoverDataLoading || this.playlistModalLoading;
    },
  },
  methods: {
    ...mapMutations([
      'slideOut',
      'triggerSnackbar',
    ]),
    ...mapActions('instructors', [
      'assignBulbSection',
      'assignPlaylistSection',
      'getAssignedDates',
      'getGroupSets',
      'getPlaylistMonitorData',
      'unassignBulbSection',
      'unassignPlaylistSection',
    ]),
    async assignSection(id) {
      if (this.assignedDates[id]) {
        this.loadingAssignedDates = true;
        await this.assignBulbSection({
          assigned_date: this.assignedDates[id] || undefined,
          bulb_id: this.dialogShow.data.id, 
          group_set_id: this.assignedGroupSets[id] || undefined,
          section_id: id,
        })
        .catch(() => {
          // trigger toast
          this.getAssignedDates(this.dialogShow.data.id);
          this.loadingAssignedDates = false;
        });
        this.loadingAssignedDates = false;
      } else {
        this.loadingAssignedDates = true;
        await this.unassignBulbSection({
          bulb_id: this.dialogShow.data.id, 
          section_id: id,
        })
        .catch((error) => {
          // trigger toast
          this.getAssignedDates(this.dialogShow.data.id);
        });
        this.loadingAssignedDates = false;
      }
    },
    async handlePlaylistAssigned(id) {
      try {
        if (this.mappedAssignedDates[id]) {
          this.loadingAssignedDates = true;
          await this.assignPlaylistSection({
            assignedDate: this.mappedAssignedDates[id],
            playlistId: this.playlist.id,
            groupSetId: undefined, // Playlists currently don't support GroupSets, but may in the future.
            sectionId: id,
          });
        } else {
          this.loadingAssignedDates = true;
          await this.unassignPlaylistSection({
            playlistId: this.playlist.id, 
            sectionId: id,
          });
        }
      } catch (e) {
        this.triggerSnackbar({
          text: 'Error assigning playlist',
          color: 'error',
          timeout: 5000,
        });
      } finally {
        // Refreshes data
        await this.getPlaylistMonitorData(this.playlist.id);
        this.mapPlaylistAssignedDates();
        this.loadingAssignedDates = false;
      }
    },
    async assignGroup(id) {
      await this.assignBulbSection({
        assigned_date: this.assignedDates[id] || undefined,
        bulb_id: this.dialogShow.data.id,
        group_set_id: this.assignedGroupSets[id] || null,
        section_id: id,
      })
      .catch(() => {
        // trigger toast
        this.getAssignedDates(this.dialogShow.data.id);
      });
    },
    broadcast(sectionId) {
      // create code by base64_encode bulb_section_id
      const code = btoa(this.assignedBulbSections[sectionId]); // use sectionId to get bulbSectionId from assignedBulbSection map, convert to hash for broadcast launch
      window.open(`/player_v2/?section_id=${sectionId}&type=broadcast&code=${code}&bulb_id=${this.dialogShow.data.id}&token=${this.instructorData.token}`);
    },
    mapPlaylistAssignedDates() {
      this.mappedAssignedDates = {};
      for (const playlistSection of this.playlistAssignedDates) {
        if (playlistSection) this.$set(this.mappedAssignedDates, playlistSection.sectionId, playlistSection.assignedDate);
      }
    },
  },
  watch: {
    'playlistAssignedDates' (n) {
      if (n) this.mapPlaylistAssignedDates();
    },
  },
  async mounted() {
    // Get groupSets for bulb assigning - not playlist assigning
    if (!this.assignPlaylist) await this.getGroupSets();
  },
};
</script>

<style scoped>
  @media only screen and (max-width: 600px) {
    .datepicker {
      width: 160px !important;
    }
    .group-select {
      width: 100px !important;
      margin-left: 20px;
    }
    .link-text {
      display: none;
    }
    .link-icon {
      margin-right: 0px !important;
    }

    .link-button {
      min-width: 0 !important;
      margin: 0 !important;
    }
  }
  .googleAvatarSmall {
    height: 15px;
    position: absolute;
    top: -2px;
    left: 15px;
  }
  
</style>
